export default "__VITE_ASSET__BVD3HPtB__"